import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useGetCallDetailsQuery } from "../../../../../store/reservations/reservationsApi";

const SaloonCallDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useGetCallDetailsQuery(id || "", {
    skip: !id,
  });

  const onGoBack = () => {
    navigate("/saloon-home/calls");
  };

  const callResponse = data?.data;

  console.log({callResponse})
  return callResponse ? (
    <div className="w-full bg-white py-5">
      <div className="flex flex-col px-4">
        <div data-qa={"back-button"} onClick={onGoBack} className=" mr-2">
			<img src="/assets/saloon/view.svg" className='rotate-180' alt="view" />
        </div>
        <p className="page-title pt-5 text-2xl">Call Details</p>
      </div>
      <div className="p-4 bg-white">
        <div className="w-full my-3">
          <h4 className="font-bold text-lg">Summary</h4>
          <p className="whitespace-pre-wrap break-words">
            {callResponse.summary}
          </p>
        </div>
        <div className="w-full  my-3">
          <h4 className="font-bold text-lg">Transcript</h4>
          <p className={"whitespace-pre-wrap break-words"}>
            {callResponse.transcript}
          </p>
        </div>
        <div className="w-full my-5">
          <h4 className="font-bold text-lg">Call Started</h4>
          <p className="">
            {moment(callResponse.callStarted).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        </div>
        <div className="w-full my-5">
          <h4 className="font-bold text-lg">Call Ended</h4>
          <p className="">
            {moment(callResponse.callEnded).format("DD/MM/YYYY HH:mm:ss")}
          </p>
        </div>
        <div className="w-full my-5">
          <h4 className="font-bold text-lg">Ended Reason</h4>
          <p className="">{callResponse.endedReason}</p>
        </div>
        <div className="w-full my-5">
          <h4 className="font-bold text-lg">Success Evaluation</h4>
          <p className="">{callResponse.successEvaluation}</p>
        </div>
        {Boolean(callResponse.structuredData) && <div className="w-full my-5">
          <h4 className="font-bold text-lg">Title</h4>
          <p className="">{callResponse.structuredData.title}</p>
        </div>}
        <div className="w-full my-5">
          <h4 className="font-bold py-3 text-lg">Play Voice Recording</h4>
          <p className="">
            <audio controls>
              <source src={callResponse.recordingUrl} type="audio/wav"></source>
            </audio>
          </p>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SaloonCallDetails;
